import { ExternalLink } from 'lucide-react';

import { what3WordsUrl } from '@/components/map/utils/poiFeatureProperties';

import { What3WordsLogo } from './What3WordsLogo';

interface What3WordsFieldProps {
    /** The what3words address (e.g. "gave.pedicure.shipyards"), or null/undefined when absent. */
    value: string | null | undefined;
}

/**
 * The what3words value rendered as the official "///" brand badge followed by a link to
 * map.what3words.com with an external-link icon. Falls back to an em dash when no value is
 * present. Shared by the POI hover card and the SAVI air-valve hover card so the w3w
 * presentation stays identical across the map.
 */
export function What3WordsField({ value }: What3WordsFieldProps) {
    return (
        <span className="inline-flex items-center gap-2">
            <What3WordsLogo className="size-6 shrink-0" />
            {value ? (
                <a
                    href={what3WordsUrl(value)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary inline-flex items-center gap-2 text-sm underline underline-offset-2"
                >
                    {value}
                    <ExternalLink className="size-4" strokeWidth={1.5} aria-hidden="true" />
                </a>
            ) : (
                <span className="text-muted-foreground text-sm">—</span>
            )}
        </span>
    );
}
